import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid, isPristine } from 'redux-form'
import { Button } from 'react-bootstrap'
import { FORM_BUSQUEDACPA } from '../../../../../config/forms'
import CamposBusquedaCpa from '../../../components/CamposBusquedaCpa'
import { COLORES } from '../../../../../config/colores'

function BusquedaCpa0 (props) {
  const { handleSubmit, invalid, pristine } = props

  return (
    <div className='camiones-busqueda-container'>
      <form onSubmit={handleSubmit}>
        <br />
        <h5><em>Criterio de búsqueda</em></h5>
        <p>Ingrese al menos uno de los datos que posea de la carta de porte</p>

        <CamposBusquedaCpa />

        <Button
          style={{ backgroundColor: COLORES.grey.dark, color: 'white' }}
          type='submit'
          disabled={invalid || pristine}
          size='md'
        >
            Buscar
        </Button>
      </form>
    </div>
  )
}

const mapStateToProps = (state) => ({
  invalid: isInvalid(FORM_BUSQUEDACPA)(state),
  pristine: isPristine(FORM_BUSQUEDACPA)(state)
})

const withRedux = connect(mapStateToProps, null)

const withReduxForm = reduxForm({
  form: FORM_BUSQUEDACPA,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})

export default withRedux(withReduxForm(BusquedaCpa0))
